export function decodeJwtPayload(token) {
  if (!token) return null
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      window.atob(base64).split('').map(c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join('')
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

export function isStaffUser() {
  const payload = decodeJwtPayload(localStorage.getItem('access_token'))
  return payload?.is_staff === true
}

const STAFF_SESSION_KEY = 'staff_session_token'

export function getStaffSessionToken() {
  return localStorage.getItem(STAFF_SESSION_KEY)
}

export function setStaffSessionToken(token) {
  if (token) localStorage.setItem(STAFF_SESSION_KEY, token)
  else localStorage.removeItem(STAFF_SESSION_KEY)
}

export function clearStaffSessionToken() {
  localStorage.removeItem(STAFF_SESSION_KEY)
}

export function isStaffApiUrl(url) {
  return typeof url === 'string'
    && url.includes('/api/staff/')
    && !url.includes('/api/staff/mfa/')
}
